import { itemReducers } from './items'
import { layoutReducers } from './layout'
import { uiReducers } from './ui'
import { collectionReducers } from './collection'
import { canvasReducer } from './canvas'
import { pageReducers } from './page'

export const studioReducers = {
    ...itemReducers,
    ...layoutReducers,
    ...uiReducers,
    ...collectionReducers,
    ...canvasReducer,
    ...pageReducers
}
